// ─── Metrics ─────────────────────────────────────────────────────────
// The numbers shown in Impact, each tied to the experience bullet it came from.

// Every number below appears verbatim in the experience bullets in src/constants/index.js.
export const metrics = [
    {
        id: "posts",
        value: 25,
        suffix: "M+",
        label: "posts published per month",
        context: "Social Planner · HighLevel",
        size: "lg",
        tone: "acc",
    },
    {
        id: "uptime",
        value: 99.2,
        decimals: 1,
        suffix: "%",
        label: "platform uptime",
        context: "across major social platforms",
        size: "md",
        tone: "acc",
        bar: 99.2,
    },
    {
        id: "media",
        value: 75,
        suffix: "M+",
        label: "media assets optimized per month",
        context: "scalable media pipelines",
        size: "md",
        tone: "acc2",
    },
    {
        id: "accounts",
        value: 6,
        suffix: "M+",
        label: "connected accounts kept authenticated",
        context: "CRON-based proactive token refresh",
        size: "md",
        tone: "acc2",
    },
    {
        id: "token",
        value: 98,
        suffix: "%+",
        label: "fewer auth / token failures",
        context: "proactive refresh system",
        size: "sm",
        tone: "acc",
        bar: 98,
    },
    {
        id: "tickets",
        value: 85,
        suffix: "%",
        label: "fewer posting support tickets",
        context: "media optimization pipelines",
        size: "sm",
        tone: "acc",
        bar: 85,
    },
    {
        id: "cpu",
        value: 95,
        suffix: "%",
        label: "reduction in worker CPU / memory spikes",
        context: "concurrency safeguards · Pub/Sub · Cloud Tasks",
        size: "sm",
        tone: "acc",
        bar: 95,
    },
    {
        id: "tests",
        value: 5200,
        suffix: "+",
        label: "unit tests added",
        context: "97%+ coverage on critical modules",
        size: "md",
        tone: "acc3",
    },
    {
        id: "coverage",
        value: 97,
        suffix: "%+",
        label: "test coverage",
        context: "release safety · regression detection",
        size: "sm",
        tone: "acc3",
        bar: 97,
    },
    {
        id: "services",
        value: 10,
        suffix: "+",
        label: "distributed services observed",
        context: "Superset · Snowflake · Grafana dashboards",
        size: "sm",
        tone: "acc2",
    },
    {
        id: "team",
        value: 12,
        suffix: "",
        label: "engineers led",
        context: "ATMECS · HyperloopTT projects",
        size: "sm",
        tone: "acc3",
    },
    {
        id: "releases",
        value: 50,
        suffix: "%",
        label: "faster feature releases",
        context: "Agile · 100% on-time deliveries",
        size: "sm",
        tone: "acc3",
        bar: 50,
    },
    {
        id: "ai",
        value: 90,
        suffix: "%",
        label: "of users helped to make job decisions",
        context: "FastAPI AI evaluation service",
        size: "sm",
        tone: "acc2",
        bar: 90,
    },
];
